import {post,get} from '../../libs/ajax.js'

export default {

    /* 工单管理 公共 查询与表格 设置*/

    // 工单详情全部下载 公共部分
    orderDown:(data,options) => {
        return post('/work_order/attachment_download', data, options);
    },
    // 获取表格自定义字段
    getCustomField:(data,options) => {
        return get('/custom_field/v1/get', data, options);
    },
    // 修改自定义过滤条件
    editCustomField:(data,options) => {
        return post('/custom_field/v1/edit', data, options);
    },

    // 工单 筛选 远程搜索部分枚举值
    postSearchWorkOrderMethodOptions:(data,options) => {
        return post('/work_order/get_search_list', data, options);
    },
    // 排单管理 筛选 远程搜索（独立接口·挂7543·BUG-002-AY·解无工单管理权用户403）
    postScheduleManageSearchList:(data,options) => {
        return post('/work_order/schedule_manage/get_search_list', data, options);
    },
    // 工单管理 - 列表
    postWorkOrderGetList:(data,options) => {
        return post('/work_order/get_list', data, options);
    },

    // 工单详情 - 工单信息
    getWorkOrderInfo:(data,options) => {
        return get('/work_order/get_work_order_info', data, options);
    },
    // 工单详情 - 工单流转
    getWorkOrderLog:(data,options) => {
        return get('/work_order/get_work_order_log', data, options);
    },
    // 工单详情 - 获取详情任务列表
    getWorkOrderDetailList:(data,options) => {
        return get('/work_order/get_detail_list', data, options);
    },
    // 工单详情 - 获取素材列表
    getWorkOrderMaterialList: (data, options) => {
        return get('/work_order/get_material_list', data, options);
    },
    // 工单详情 - 批量通过
    postWorkOrderBatchPass:(data,options) => {
        return post('/work_order/batch_pass', data, options);
    },
    // 工单详情 - 通过
    postWorkOrderPass:(data,options) => {
        return post('/work_order/pass', data, options);
    },

    // 工单详情 - 提前结单
    getWorkOrderCheckFinish:(data,options) => {
        return get('/work_order/check_finish', data, options);
    },

    // 工单详情 - 批量拒绝
    postWorkOrderBatchReject:(data,options) => {
        return post('/work_order/batch_rejected', data, options);
    },
    // 工单详情 - 拒绝
    postWorkOrderReject:(data,options) => {
        return post('/work_order/rejected', data, options);
    },
    // 工单详情 - 批量下载
    postWorkOrderDownLoad:(data,options) => {
        return post('/work_order/batch_download', data, options);
    },
    // 工单详情 - 下载
    postWorkOrderOnlyDownLoad:(data,options) => {
        return post('/work_order/download', data, options);
    },
    // 工单详情 - 单独素材下载
    postWorkOrderOnlyMaterialDownLoad:(data,options) => {
        return post('/work_order/download_material', data, options);
    },
    // 工单详情 - 结单
    postWorkOrderFinish:(data,options) => {
        return post('/work_order/finish', data, options);
    },
    // 工单详情 - 撤回
    postWorkOrderDelete:(data,options) => {
        return post('/work_order/delete', data, options);
    },
    // 工单-获取顶部提醒
    getWorkOrderMsg:(data,options) => {
        return get('/work_order/get_remind', data, options);
    },
    // 工单详情 - 获取素材列表通过订单
    getWorkOrderMaterialByOrderList: (data, options) => {
        return get('/work_order/get_material_list_by_material', data, options);
    },
    // 工单-获取任务筛选数据
    getWorkOrderTaskFilterData: (data, options) => {
        return get('/work_order/get_detail_ids', data, options);
    },


    // 指派管理+ - 筛选
    getSearchList:(data,options) => {
        return get('/order_assign/get_search_list', data, options);
    },
    // 指派 下拉部分枚举值
    getSearchWorkOrderOptions:(data,options) => {
        return get('/work_order/search_config', data, options);
    },
    // 指派 筛选 远程搜索部分枚举值
    postSearchOrderAssignMethodOptions:(data,options) => {
        return post('/order_assign/get_search_list', data, options);
    },
    // 指派管理 - 列表
    postOrderAssignGetList:(data,options) => {
        return post('/order_assign/get_list', data, options);
    },
    // 指派管理 - 工单信息
    getWorkAssignOrderInfo:(data,options) => {
        return get('/order_assign/get_work_order_info', data, options);
    },
    // 指派管理 - 工单流转
    getWorkAssignOrderLog:(data,options) => {
        return get('/order_assign/get_work_order_log', data, options);
    },
    // 指派管理 - 获取详情任务列表
    getWorkAssignOrderDetailList:(data,options) => {
        return get('/order_assign/detail_list', data, options);
    },
    // 指派管理 - 制作人 options
    getAssignOrderProducer:(data,options) => {
        return get('/order_assign/producer', data, options);
    },
    // 任务管理 - 素材分类标签字典按级分组（说明弹层·workOrder_v4）
    getMaterialNameLabels:(data,options) => {
        return get('/order_task/material_name_labels', data, options);
    },
    // 指派管理 - 组内分配水位（workOrder_v4）
    getAssignMemberWater:(data,options) => {
        return post('/order_assign/member_water', data, options);
    },
    // 指派管理 - 统一指派
    postAssignOrderAll:(data,options) => {
        return post('/order_assign/assign_all', data, options);
    },
    // 指派管理 - 分任务指派
    postAssignOrderTask:(data,options) => {
        return post('/order_assign/assign_by_task', data, options);
    },
    // 指派管理 - 重新指派
    postRedoAssignOrderTask:(data,options) => {
        return post('/order_assign/redo_assign_by_task', data, options);
    },
    // 指派管理 - 指派列表-驳回
    postAssignOrderReject:(data,options) => {
        return post('/order_assign/reject', data, options);
    },

    // 任务管理 筛选 远程搜索部分枚举值
    postSearchOrderTaskMethodOptions:(data,options) => {
        return post('/order_task/get_search_list', data, options);
    },
    // 任务管理 - 列表
    postOrderTaskGetList:(data,options) => {
        return post('/order_task/get_list', data, options);
    },
    // 任务管理 - 工单信息
    getWorkTaskInfo:(data,options) => {
        return get('/order_task/get_work_order_info', data, options);
    },
    // 任务管理 - 工单流转
    getWorkTaskLog:(data,options) => {
        return get('/order_task/get_work_order_log', data, options);
    },
    // 任务管理 - 获取详情任务列表
    getWorkTaskDetailList:(data,options) => {
        return get('/order_task/get_detail_list', data, options);
    },
    // 任务管理 - 获取素材列表
    getWorkTaskMaterialList:(data,options) => {
        return get('/order_task/get_detail_material_list', data, options);
    },
    // 任务管理 - 素材列表删除
    postWorkTaskBatchDelete:(data,options) => {
        return post('/order_task/detail_material/delete', data, options);
    },
    // 任务管理 - expand 删除
    postWorkTaskBatchDeleteExpand:(data,options) => {
        return post('/order_task/detail_material/batch_delete', data, options);
    },
    // 任务管理-获取顶部提醒
    getWorkTaskMsg:(data,options) => {
        return get('/order_task/detail_material/get_material_remind', data, options);
    },
    // 任务管理工单上传-点击上传按钮验证是否可以上传
    checkBeforeUpload(data) {
        return post('/order_task/detail_material/upload_check', data)
    },
    // 任务管理 - 批量下载
    postOrderTaskDownLoad:(data,options) => {
        return post('/order_task/detail_material/batch_download', data, options);
    },
    postOrderTaskOnlyDownLoad:(data,options) => {
        return get('/order_task/detail_material/download_material', data, options);
    },
    // 任务管理 - 获取任务列表通过订单
    getWorkTaskDetailByOrderList: (data, options) => {
        return get('/order_task/get_material_list_by_material', data, options);
    },
    // 任务管理-获取任务筛选数据
    getWorkTaskFilterData: (data, options) => {
        return get('/order_task/get_detail_ids', data, options);
    },
    // 任务管理-列表批量下载工单素材（异步打包 ZIP，走离线下载中心）
    batchDownloadOrderMaterial: (data, options) => {
        return post('/order_task/batch_download_order_material', data, options);
    },

    // 素材库 - 批量下载
    getOnlyDownLoad:(data,options) => {
        return get('/material_storehouse/download', data, options);
    },
    // 素材工单 - 更新工单标签
    updateWorkOrderLabelApi:(data,options) => {
        return post(`/${ data.type }/update_work_order_label`, data, options);
    },
    // 任务管理 - 修改落点时间（单行/批量共用·data:{order_ids:[], delivery:'Y-m-d', reason:≤50字}·节点 task_delivery_edit）
    batchUpdateDeliveryApi:(data,options) => {
        return post('/order_task/batch_update_delivery', data, options);
    },

    // 指派管理 - 列表-获取所有指派信息
    getWorkAssignOrderAllInfo:(data,options) => {
        return post('/order_assign/get_all_assign_info', data, options);
    },
    // 指派管理 - 列表-根据素材指派
    postAssignOrderByMaterial:(data,options) => {
        return post('/order_assign/assign_by_material', data, options);
    },
    // 指派管理 - 列表-重新指派所有
    postRedoAssignOrderAll:(data,options) => {
        return post('/order_assign/redo_assign_all', data, options);
    },
    // 指派管理 - 列表-重新指派所有-根据素材
    postRedoAssignOrderAllByMaterial:(data,options) => {
        return post('/order_assign/redo_assign_by_material', data, options);
    },
}
